import type { ConvoyTrackSegment } from './types';

function interiorsOverlap(
  a: { startSec: number; endSec: number },
  b: { startSec: number; endSec: number },
): boolean {
  return a.startSec < b.endSec && b.startSec < a.endSec;
}

/**
 * ColorIndex: sole / unique-largest group in a time window → 0 (status).
 * Parallel groups (strict interior overlap): largest then groupKey → 0, 1, 2, …
 * Adjacent windows that only touch at an endpoint are not parallel.
 */
export function assignSegmentColorIndices(
  segments: ConvoyTrackSegment[],
): ConvoyTrackSegment[] {
  if (segments.length === 0) return segments;

  const colorById = new Map<string, number>();

  for (const seg of segments) {
    if (colorById.has(seg.id)) continue;

    const cohort = segments.filter((o) => interiorsOverlap(seg, o));

    if (cohort.length <= 1) {
      colorById.set(seg.id, 0);
      continue;
    }

    const ranked = [...cohort].sort((a, b) => {
      if (b.memberDeviceIds.length !== a.memberDeviceIds.length) {
        return b.memberDeviceIds.length - a.memberDeviceIds.length;
      }
      return a.groupKey.localeCompare(b.groupKey);
    });

    ranked.forEach((s, idx) => {
      if (!colorById.has(s.id)) colorById.set(s.id, idx);
    });
  }

  return segments.map((s) => ({
    ...s,
    colorIndex: colorById.get(s.id) ?? 0,
  }));
}
